import hasWindow from 'utils/globals/hasWindow';

const getDefaultSearchFromUrl = (key) => {
  const search = new URLSearchParams(
    hasWindow() ? window?.location?.search : undefined
  );
  let params: string | string[] | undefined = search.getAll(key);
  if (params.length === 0) params = undefined;
  else if (params.length === 1) params = params[0];

  return params;
};

export default getDefaultSearchFromUrl;
